export const PHX_STORE_TYPES = ['Pharmaprix', 'Pharmaprix Simplement Santé'] as const;
export const SDM_STORE_TYPES = ['Shoppers Drug Mart', 'Shoppers Simply Pharmacy', 'Specialty Care Centre'] as const;
export const PHX_COMPLIANT_PARAMS = { PHARMACY_SERVICES: 'pharmacy-services', STORE_HOURS: 'store-hours' };
export const PHX_COMPLIANT_CODES = { PHARMACY_SERVICES: 'pharmacyServices', STORE_HOURS: 'storeHours' };
export const FILTER_ORDER = ['storeType', 'storeHours', 'storeServices', 'pharmacyServices', 'beautyBrands'];
